import { Loader } from "@googlemaps/js-api-loader";

const mapContainer = document.querySelector('.map-main');

if (mapContainer && mapContainer.dataset.lat && mapContainer.dataset.lng) {
    const loader = new Loader({
        apiKey: "AIzaSyAm5ycUJH0_N4Gd0-9P0MwnExXXTTgL0vE",
        version: "weekly",
        libraries: ["marker"]
    });

    loader.importLibrary('maps').then(() => {
        const { Map } = google.maps;
        const { AdvancedMarkerElement } = google.maps.marker;

        const lat = parseFloat(mapContainer.dataset.lat);
        const lng = parseFloat(mapContainer.dataset.lng);
        if (isNaN(lat) || isNaN(lng)) return;

        // Init map
        const map = new Map(mapContainer, {
            center: { lat, lng },
            zoom: 10,
            mapId: "7e1c4c732de8a407",
            mapTypeControl: false,
            streetViewControl: false,
            zoomControl: true
        });

        // Use your site asset as marker
        const markerEl = document.createElement('div');
        markerEl.innerHTML = `
            <img src="/assets/icons/pin.svg" alt="Location Pin" style="width:32px;height:auto;" />
        `;

        new AdvancedMarkerElement({
            position: { lat, lng },
            map,
            content: markerEl,
        });
    }).catch(e => {
        console.error("Error loading Google Maps:", e);
    });
}
